import React from "react"
/*
 * VWO Image component for displaying images in A/B tests
 * AB Test | NSF Certificate on HGN PDPs - 7/14
 */
const VwoImage = ({ item }) => {
  const {
    image = null,
    className = ``,
    alt = ``,
    name = ``,
    imageA = null,
    classNameA = ``,
    altA = ``,
    nameA = ``,
  } = item

  if (!image) {
    return null
  }
  return (
    <>
      <img src={image} alt={alt || name} className={className} />
      {imageA && className && classNameA ? (
        <img
          src={imageA}
          alt={altA || nameA || alt || name}
          className={classNameA}
        />
      ) : null}
    </>
  )
}
export default VwoImage
